import { render } from "./PostFilters.vue?vue&type=template&id=5df7d87f&scoped=true"
import script from "./PostFilters.vue?vue&type=script&lang=js"
export * from "./PostFilters.vue?vue&type=script&lang=js"

import "./post-filters.scss?vue&type=style&index=0&id=5df7d87f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df7d87f"]])

export default __exports__